import { useEffect, useRef } from 'react';

export function useInterval(callback: () => void, delay: number | null): void {
  const savedCallback = useRef(callback);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    if (delay === null) return undefined;

    const intervalId = setInterval(() => {
      savedCallback.current();
    }, delay);

    return () => clearInterval(intervalId);
  }, [delay]);
}
